import TableList from "@components/templates/tablelist";
import {
    HttpOtherSfpList,
    HttpOtherRetrySfp,
    HttpOtherIgnoreSfp,
    HttpOtherSfpLog
} from "@/service/sfp/sfp";
import { mapState } from "vuex";
export default {
    mixins: [TableList],
    components: {
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Plugins: { show: true },
            formData: {
                search: {
                    EQ_isDeal: null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90
            }
        };
    },
    methods: {
        ajaxRequest: HttpOtherSfpList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "retry":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { ids: params },
                        title: "重推操作",
                        ajaxRequest: HttpOtherRetrySfp
                    };
                    break;
                case "ignore":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "忽略操作",
                        ajaxRequest: HttpOtherIgnoreSfp
                    };
                    break;
                case "log":
                    this.operate = {
                        show: true,
                        width: 1000,
                        params: { id: params },
                        title: "查看日志",
                        ajaxRequest: HttpOtherSfpLog,
                        showFooter: false,
                        component: "compLog"
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, isDeal } = row,
                show = isDeal == '0';
            return [
                {
                    label: "重推",
                    show,
                    params: id,
                    operate: "retry"
                },
                {
                    label: "忽略",
                    show,
                    params: id,
                    operate: "ignore"
                },
                {
                    label: "查看日志",
                    show: true,
                    params: id,
                    operate: "log"
                }
            ];
        }
    },

    computed: {
        ...mapState("boss", ["accounts", "products", "warehouseList"]),
        TabsData() {
            return [
                {
                    name: "所有",
                    key: "EQ_isDeal",
                    val: null
                },
                {
                    name: "异常",
                    key: "EQ_isDeal",
                    val: "0"
                }
            ];
        },
        ToolsData() {
            return [
                {
                    name: "重推仓库",
                    operate: "retry",
                    theme: "primary",
                    batch: true
                }
            ];
        },
        SearchsData() {
            const dropStyle = "width:auto;min-width:186px;";
            return [
                {
                    label: "订单号",
                    tag: "vInput",
                    key: "CN_ordernum",
                    show: true
                },
                {
                    label: "渠道",
                    tag: "vSelect",
                    key: "EQ_accountId",
                    show: true,
                    options: this.accounts.map(item => {
                        const { id, title } = item;
                        return {
                            value: id,
                            label: title
                        };
                    }),
                    props: {
                        dropStyle,
                        filterable: true
                    }
                },
                {
                    label: "项目",
                    tag: "vSelect",
                    key: "EQ_lineId",
                    show: true,
                    options: this.products.map(function (item) {
                        const { id, name } = item;
                        return {
                            value: id,
                            label: name
                        };
                    }),
                    props: {
                        dropStyle,
                        filterable: true
                    }
                }
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id"
                },
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "订单号",
                    key: "ordernum",
                    render(h, { row }) {
                        const { ordernum, orderId } = row;
                        return (
                            <div>
                                <div class="color-primary">{orderId}</div>
                                <div>{ordernum}</div>
                            </div>
                        );
                    }
                },
                {
                    title: "渠道账号",
                    key: "accountId"
                },
                {
                    title: "项目/金额",
                    key: "lineId",
                    render: (h, { row }) => {
                        const { lineId, amount, currencyCode } = row;
                        const { name } =
                            this.products.find(function (item) {
                                return item.id == lineId;
                            }) || {};
                        return `${name} / ${amount}${currencyCode}`;
                    }
                },
                {
                    title: "仓库/发货方式",
                    key: "orgWarehouseId",
                    render: (h, { row }) => {
                        const { orgWarehouseId, shippingMethodCode } = row;
                        const { title } =
                            this.warehouseList.find(function (item) {
                                return item.id == orgWarehouseId;
                            }) || {};
                        return `${title} / ${shippingMethodCode}`;
                    }
                },
                {
                    title: '状态',
                    key: 'message',
                    render: (h, { row }) => {
                        return row.isDeal == '0' ? row.message : '正常'
                    }
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                    render(h, { row }) {
                        const { updatedAt, created, latestShipDate } = row;
                        return (
                            <div>
                                <div>创建时间:{created}</div>
                                <div>更新时间:{updatedAt}</div>
                                <div>最晚发货时间:{latestShipDate}</div>
                            </div>
                        );
                    }
                }
            ];
        }
    }
};
